
export default {
	name: "AboutCTAButton",
	props: {
		to: {
			type: String,
			default: "",
		},
		href: {
			type: String,
			default: "",
		},
	},
};
